import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Progress } from './ui/progress';
import { Check, Circle, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const ChecklistItem = ({ completed, label, learnMoreUrl }) => (
    <div className="flex items-start gap-3 py-2">
        <div className="mt-0.5">
            {completed ? (
                <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
                    <Check className="h-3 w-3 text-white" />
                </div>
            ) : (
                <Circle className="h-5 w-5 text-muted-foreground/40" />
            )}
        </div>
        <div className="flex-1 min-w-0">
            <p className={`text-sm ${completed ? 'text-foreground' : 'text-muted-foreground'}`}>
                {label}
            </p>
            {learnMoreUrl && (
                <Button
                    variant="ghost"
                    size="sm"
                    className="h-auto p-0 text-xs text-muted-foreground hover:text-foreground mt-0.5"
                    onClick={() => window.open(learnMoreUrl, '_blank')}
                >
                    Learn more
                    <ExternalLink className="h-3 w-3 ml-1" />
                </Button>
            )}
        </div>
    </div>
);

const IntegrationChecklist = ({ integrationProgress = {} }) => {
    const items = [
        { key: 'flowCreated', label: 'Create a flow', learnMoreUrl: null },
        { key: 'screenAdded', label: 'Add at least 1 screen', learnMoreUrl: null },
        { key: 'previewOpened', label: 'Preview on device', learnMoreUrl: null },
        { key: 'sdkInstalled', label: 'Install SDK', learnMoreUrl: 'https://docs.poponboarding.com/essentials/webview-integration' },
        { key: 'onboardingStarted', label: 'Trigger onboarding start event', learnMoreUrl: 'https://docs.poponboarding.com/quickstart' },
        { key: 'flowPublished', label: 'Publish flow', learnMoreUrl: null },
    ];

    const completedCount = items.filter(item => integrationProgress[item.key]).length;
    const totalCount = items.length;
    const percentage = Math.round((completedCount / totalCount) * 100);

    // Hide if 100% complete
    if (percentage === 100) {
        return null;
    }

    return (
        <Card className="mb-6 w-full">
            <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                    <CardTitle className="text-base font-semibold flex items-center gap-2">
                        🚀 Setup Progress
                    </CardTitle>
                    <span className="text-sm font-medium text-muted-foreground">{percentage}%</span>
                </div>
            </CardHeader>
            <CardContent className="space-y-4">
                <Progress value={percentage} className="h-2" />
                <div className="space-y-1">
                    {items.map((item) => (
                        <ChecklistItem
                            key={item.key}
                            completed={integrationProgress[item.key]}
                            label={item.label}
                            learnMoreUrl={item.learnMoreUrl}
                        />
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};

export default IntegrationChecklist;
